<template>
  <div>
    <section class="section section-blog_navigation align-items-center d-flex bg-not-selected no-padding py-1 py-md-0 bg-nelson-blue position-fixed w-100">
      <div class="container">
        <div class="row d-none d-md-flex">
          <div class="align-items-center d-flex">
            <button class="btn" @click="toggleShowSearchText()" title="Search Thinking Posts" aria-label="Search Thinking Posts"><i class="fal fa-search fz-24"></i></button>
          </div>
          <div class=" align-items-center d-flex">
            <div class="input-group color-dark-gray px-2 animated fadeIn display-inline-block" v-if="showSearchText">
              <input type="text" class="form-control" placeholder="Search Posts" aria-label="Search Posts" v-model="searchString">
              <div class="input-group-append">
                <button class="btn btn-dark " type="button" @click="searchPosts()">Search</button>
              </div>
            </div>
          </div>
          <div class="flex-grow-1 align-items-center d-flex">
            <span class="ml-24 fz-20">Filter by:</span>
            <button class="badge badge-muted-blue badge-pill ml-24" @click.stop.prevent="setCategory(category.id)" v-for="category in thinkingCategories" :key="category.id"><span>{{category.name}}</span></button>
            <!-- <button class="badge badge-muted-blue badge-pill ml-24" @click.stop.prevent="setCategory('all')">Recent</button> -->
            <!-- <button class="badge badge-muted-blue badge-pill ml-24" @click.stop.prevent="setCategory(22)">Press</button>
            <button class="badge badge-muted-blue badge-pill ml-24" @click.stop.prevent="setCategory(1521)">Awards</button>
            <button class="badge badge-muted-blue badge-pill ml-24" @click.stop.prevent="setCategory(20)">Creative Fuel</button> -->
          </div>
        </div>
        <div class="row d-flex d-md-none justify-content-start align-items-center">
          <span class="fz-24 ml-3">Filter Thoughts:</span>
          <button class="btn" @click="mobileDisplaySearchText()"><i class="fal fa-search fz-24"></i></button>
          <button class="btn" @click="mobileDisplayFilters()"><i class="fal fa-filter fz-24"></i></button>
        </div>
        <div class="mobile-filters-search" v-if="mobileShowFiltersSearchDiv">
          <div class="input-group color-dark-gray px-2 animated fadeIn display-inline-block" v-if="mobileShowSearchText">
            <input type="text" class="form-control" placeholder="Search Posts" aria-label="Search Posts" v-model="searchString">
            <div class="input-group-append">
              <button class="btn btn-dark " type="button" @click="searchPosts(); mobileHideSearchText();">Search</button>
            </div>
          </div>
          <div class="text-center py-1" v-if="mobileShowFilters">
            <span class="fz-20 d-block mb-1">Filter by:</span>
            <button class="badge badge-muted-blue badge-pill d-block mx-auto mb-1" @click.stop.prevent="setCategory(category.id); mobileHideFilters();" v-for="category in thinkingCategories" :key="category.id"><span>{{category.name}}</span></button>
            <!-- <button class="badge badge-muted-blue badge-pill d-block mx-auto mb-1" @click.stop.prevent="setCategory('all'); mobileHideFilters();">Recent</button>
            <button class="badge badge-muted-blue badge-pill d-block mx-auto mb-1" @click.stop.prevent="setCategory(22); mobileHideFilters();">Press</button>
            <button class="badge badge-muted-blue badge-pill d-block mx-auto mb-1" @click.stop.prevent="setCategory(1521); mobileHideFilters();">Awards</button>
            <button class="badge badge-muted-blue badge-pill d-block mx-auto mb-1" @click.stop.prevent="setCategory(20); mobileHideFilters();">Creative Fuel</button> -->
          </div>
          <a href="" class="mx-auto d-block fz-16 mt-2 text-center" @click.stop.prevent="closeFiltersSearch();">Close <i class="fal fa-chevron-up ml-1"></i> </a>
        </div>
      </div>
      <div class="sr-alert sr-only" role="alert" v-html="srAlert"></div>
    </section>
  </div> 
</template>
<script>
const axios = require('axios');

export default {
  created() {
    this.getThinkingCategories();
    // console.info('posts created');
  },
  mounted() {
    // console.log('posts mounted');
  },
  methods: {
      setCategory: function(category){
          app.posts.postsApp.setCategory(category);
          let $this = this;
          this.srAlert = "";
          setTimeout(function(){
            $this.srAlert = "Posts have been updated";
            let $target = document.querySelectorAll(".section-blog_posts .post-item:first-child a:first-child");
            $target[0].focus();
          },500);
      },
      searchPosts: function(){
        app.posts.postsApp.searchPosts(this.searchString);
        let $this = this;
        this.srAlert = "";
        setTimeout(function(){
          $this.srAlert = "Posts have been updated";
          let $target = document.querySelectorAll(".section-blog_posts .post-item:first-child a:first-child");
          $target[0].focus();
        },500);
      },
      toggleShowSearchText: function(){
        this.showSearchText = ! this.showSearchText;
      },
      mobileDisplaySearchText: function(){
        this.mobileShowSearchText = true;
        this.mobileShowFilters = false;
        this.mobileShowFiltersSearchDiv = true;
      },
      mobileDisplayFilters: function(){
        this.mobileShowFilters = true;
        this.mobileShowSearchText = false;
        this.mobileShowFiltersSearchDiv = true;
      },
      mobileHideSearchText: function(){
        this.mobileShowSearchText = false;
        this.mobileShowFiltersSearchDiv = false;
      },
      mobileHideFilters: function(){
        this.mobileShowFilters = false;
        this.mobileShowFiltersSearchDiv = false;
      },
      closeFiltersSearch: function(){
        this.mobileShowFiltersSearchDiv = false;
      },
      getThinkingCategories(category = 'all', page = 0, take = 12){
        this.$set(this, 'loading', true);
          axios.get(`${this.api.prefix}${this.api.thinkingCategories}`)
          .then(categories => {
            this.$set(this, 'loading', false);
            this.thinkingCategories = categories.data;
            // console.log(this.thinkingCategories);
          }).catch(err => {
            this.$set(this, 'loading', false);
          });
      },
  }, 
  data: {
    showSearchText: false,
    mobileShowSearchText: false,
    mobileShowFilters: false,
    mobileShowFiltersSearchDiv: false,
    searchString: '',
    srAlert: '',
    thinkingCategories: [],
    api: {
				prefix: '/wp-json/usdp/v1/',
				thinkingCategories: 'thinking/categories/'
			},
  }
};
</script>
